/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_SinceInputs */

const en_us2_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Since when?`)
};

const pt_br2_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde quando?`)
};

const es_419_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Desde cuándo?`)
};

const pt_pt2_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde quando?`)
};

const fr_fr2_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depuis quand ?`)
};

const de_de2_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit wann?`)
};

const it_it2_profile_editors_pain_since = /** @type {(inputs: Profile_Editors_Pain_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da quando?`)
};

/**
* | output |
* | --- |
* | "Since when?" |
*
* @param {Profile_Editors_Pain_SinceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_since = /** @type {((inputs?: Profile_Editors_Pain_SinceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_SinceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_since(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_since(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_since(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_since(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_since(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_since(inputs)
	return en_us2_profile_editors_pain_since(inputs)
});
export { profile_editors_pain_since as "profile-editors.pain_since" }